import theme from "@/theme";

export const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  avatar: {
    width: "46px",
    height: "46px",
  },
  editorContainer: {
    width: "100%",
    position: "relative",
    p: "0.5rem",
    minHeight: "5.625rem",
    maxHeight: "11.125rem",
    bgcolor: theme.palette.custom.blueGray100,
    borderRadius: "0.75rem",
    pb: "3rem",
    flex: 1,
  },
  editorScroll: {
    maxHeight: "7.5rem",
    overflowY: "auto",
  },
  editorWrapper: {
    flex: 1,
    overflowX: "hidden",
    maxHeight: "7.5rem",
    overflowY: "auto",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "-1%",
    color: "#000",
    wordBreak: "break-word",
    "& .public-DraftEditorPlaceholder-root": {
      fontFamily: "Inter",
      fontWeight: 600,
      fontSize: "15px",
      lineHeight: "24px",
      letterSpacing: "-1%",
      color: "#9DA6B0",
    },
  },
  bottomControls: {
    position: "absolute",
    bottom: 0,
    direction: "row",
    alignItems: "center",
    width: "calc(100% - 8px)",
    justifyContent: "space-between",
    pr: "0.5rem",
    pb: "0.5rem",
  },
  leftControls: {
    direction: "row",
    alignItems: "center",
    gap: "1rem",
  },
  emojiPicker: {
    position: "absolute",
    zIndex: 10,
    left: "-370px",
    bottom: "30px",
    maxHeight: "48vh",
  },
  sendButton: {
    cursor: "pointer",
    textTransform: "none",
    width: "65px",
    height: "40px",
    borderRadius: "8px",
    padding: "8px 16px",
    gap: "8px",
    color: "#fff",
    backgroundColor: theme.palette.custom.mainBlue,
    "&:disabled": {
      backgroundColor: "#8FBDF9",
      color: "#fff",
    },
  },
  TooltipWrapper: {
    width: 157,
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  TooltipText: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "#FFFFFF",
  },
  TooltipProps: {
    background: "#000000CC",
    borderRadius: "4px",
    px: "8px",
    py: "4px",
  },
};
